function normGender(g) {
  const v = (g || '').toLowerCase().trim();
  if (['man', 'men', 'male'].includes(v)) return 'man';
  if (['woman', 'women', 'female'].includes(v)) return 'woman';
  return 'other';
}

export function possessivePronoun(gender) {
  const g = normGender(gender);
  if (g === 'man') return 'His';
  if (g === 'woman') return 'Her';
  return 'Their';
}

export function objectPronoun(gender) {
  const g = normGender(gender);
  if (g === 'man') return 'him';
  if (g === 'woman') return 'her';
  return 'them';
}
